import jsPDF from "jspdf";
import "jspdf-autotable";
import { toWords } from "number-to-words";

export const generateInvoicePDF = (invoiceDataItem) => {
  if (!invoiceDataItem) return;

  const doc = new jsPDF();
  const margin = 8;
  const pageWidth = doc.internal.pageSize.width;
  const centerX = pageWidth / 2;

  doc.setFont("helvetica", "bold").setFontSize(14).text("HARE KRISHNA TRADERS", centerX, 13, { align: "center" });

  let addressY = 20;
  [
    "12/22, Koothanur, Mallikundam Road, Mecheri, Salem 636458",
    "Phone: 9787292119, 9789573268, 9790168814 | Email: jayaprakash892@gmail.com",
    "GSTIN: 33CFYPM6838M1ZF | State: TamilNadu (33)"
  ].forEach(line => {
    doc.setFont("helvetica", "normal").setFontSize(8).text(line, centerX, addressY, { align: "center" });
    addressY += 5;
  });

  doc.setFontSize(12).setTextColor(0, 0, 128).text("TAX INVOICE", centerX, addressY + 5, { align: "center" });

  doc.setFontSize(9).setTextColor(0, 102, 51).text("Invoice Details:", 130, addressY + 10);
  doc.setFontSize(8).setTextColor(0)
    .text(`Invoice No: ${invoiceDataItem.invoiceNo}`, 130, addressY + 15)
    .text(`Date: ${invoiceDataItem.date}`, 130, addressY + 20)
    .text(`Place of Supply: TamilNadu (33)`, 130, addressY + 25);

  doc.setFontSize(9).setTextColor(0, 102, 51).text("Bill To:", margin, addressY + 10);
  doc.setFont("helvetica", "bold").setFontSize(9).text(invoiceDataItem.shopName?.toUpperCase(), margin, addressY + 15);
  doc.setFontSize(8)
    .text(invoiceDataItem.billingAddress, margin, addressY + 21)
    .text(`Contact No: ${invoiceDataItem.shopContactNo}`, margin, addressY + 25)
    .text(`GSTIN Number: ${invoiceDataItem.shopGst}`, margin, addressY + 29)
    .text(`State: ${invoiceDataItem.shopState}`, margin, addressY + 33);

  const totals = invoiceDataItem.items?.reduce((acc, item) => ({
    totalQuantity: acc.totalQuantity + (Number(item.quantity) || 0),
    totalDiscount: acc.totalDiscount + (Number(item.discount) || 0),
    totalGST: acc.totalGST + (Number(item.gst) || 0),
    totalAmount: acc.totalAmount + (Number(item.amount) || 0),
    price: acc.price + (Number(item.pricePerUnit) * Number(item.quantity) || 0)
  }), { totalQuantity: 0, totalDiscount: 0, totalGST: 0, totalAmount: 0, price: 0 });

  doc.autoTable({
    head: [["S.NO", "Product Name", "MRP", "Qty", "Unit", "Price/Unit", "GST/Unit", "Discount", "Price", "GST", "Amount"]],
    body: [
      ...(invoiceDataItem.items?.map((item, index) => [
        index + 1,
        item.productName?.toUpperCase(),
        item.mrp,
        item.quantity,
        item.unit,
        item.pricePerUnit,
        item.gstAmountPerUnit,
        `${item.discount}%`,
        (item.pricePerUnit * item.quantity).toFixed(2),
        (item.gstAmountPerUnit * item.quantity).toFixed(2),
        item.amount
      ]) || []),
      ["TOTAL", "", "", totals.totalQuantity, "", "", "", "", totals.price.toFixed(2), totals.totalGST.toFixed(2), totals.totalAmount.toFixed(2)]
    ],
    startY: addressY + 35,
    styles: { fontSize: 8, cellPadding: 1, fontStyle: "bold" },
    headStyles: { fillColor: [0, 102, 51], textColor: [255, 255, 255] }
  });

  const finalY = doc.lastAutoTable.finalY;

  doc.autoTable({
    head: [["Description", "Amount"]],
    body: [
      ["Subtotal Price", totals.price.toFixed(2)],
      ["SGST @9%", (totals.totalGST / 2).toFixed(2)],
      ["CGST @9%", (totals.totalGST / 2).toFixed(2)],
      ["Rounded Off Total", Math.round(totals.totalAmount).toFixed(2)],
      [
        { content: "TOTAL", styles: { fillColor: [255, 204, 0] } },
        { content: totals.totalAmount.toFixed(2), styles: { fillColor: [255, 204, 0] } }
      ]
    ],
    startY: finalY,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [0, 102, 51], textColor: [255, 255, 255] },
    margin: { left: 147 }
  });

  doc.setFontSize(9).text(`Amount in words: ${toWords(Math.round(totals.totalAmount))} only`, margin, doc.lastAutoTable.finalY - 22);
  doc.save(`Invoice_${invoiceDataItem.invoiceNo}.pdf`);
};
